<!--
 * @Author: 卢靖康
 * @Date: 2019-10-31 17:52:49
 * @LastEditTime: 2021-06-05 10:00:09
 * @LastEditors: 卢靖康
-->
<template>
  <div class="page">
    <top-banner :img-url="headPicUrl" :pageTitle="title"></top-banner>
    <div class="container">
      <section-title :title="contentTitle"></section-title>
      <p v-html="companyProfile" class="desc"></p>
    </div>
    <!--中部轮播-->
    <section class="banner">
      <swiper
        :options="bannerSwiperOpts"
        ref="bannerSwiper"
        v-if="bannerImgs.length > 0"
      >
        <swiper-slide
          v-for="(item, index) in bannerImgs"
          :key="index"
          class="banner-item"
        >
          <img :src="$imgHost + item" />
        </swiper-slide>
        <div
          class="swiper-pagination"
          slot="pagination"
          v-show="bannerImgs.length > 1"
        ></div>
      </swiper>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      contentTitle: "",
      companyProfile: "",
      headPicUrl:'',
      bannerImgs: [],
      bannerSwiperOpts: {
        loop: true,
        effect: "slide",
        speed: 800,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets",
        },
        autoplay: {
          delay: 5000,
        },
      },
    };
  },
  mounted() {
    this.$api.about.getIndexData().then((res) => {
      // console.log(res.imgUrls)
      this.bannerImgs = res.bottomPicUrls || [];
      this.title = res.title || this.$i18n.t("common.联系我们");
      this.contentTitle =
        res.contentTitle || this.$i18n.t("about.companyProfile.title");
      this.companyProfile = res.content || "";
      this.headPicUrl = this.$imgHost + res.headPicUrl;
    });
  },
};
</script>

<style lang="scss" scoped>
.swiper-container {
  margin: 90px 0;
}

.desc {
  color: $text-color;
  font-size: $font-size-large;
  margin-bottom: 40px;
}

.banner-item {
  img {
    width: 100%;
    display: block;
  }
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
